import { call, put, all, takeLatest, race, take, cancelled } from "redux-saga/effects";
import { Api } from "../api";
import * as generalActions from "../actions/general";
import * as authActions from "../actions/auth";
import {parsePolygonPaths, convertWKTMultiPointToGoogleMapsPath} from "../helpers";
import { cancelable } from "./cancel";



function* backendRedirection(action) {
  try {
    const res = yield call(Api.general.backendRedirection, action.payload);
    window.location.href = `/${res.data.result}`;
    yield put({
      type: generalActions.BACKEND_REDIRECTION_SUCCESS,
      payload: res.data.result,
    });
  } catch (err) {
    yield put({
      type: generalActions.BACKEND_REDIRECTION_FAIL,
      payload: { error: err.message },
    });
  }
}

function* getRecentIncidentsHeatmap(action, cancelToken) {
  try {
    const res = yield call(Api.general.getRecentIncidentsHeatmap, action.payload, cancelToken);
    yield put({
      type: generalActions.GET_RECENT_INCIDENTS_HEATMAP_SUCCESS,
      payload: res.data.data,
    });
  } catch (err) {
    yield put({
      type: generalActions.GET_RECENT_INCIDENTS_HEATMAP_FAIL,
      payload: { error: err.message },
    });
    if (err?.response?.status === 401) yield put({ type: authActions.AUTH_LOGOUT_REQUEST });
  } finally {
    if (yield cancelled()) {
      console.log('getRecentIncidentsHeatmap cancelled');
    }
  }
}

function* getRecentIncidentsHeatmapDetails(action, cancelToken) {
  try {
    const res = yield call(Api.general.getRecentIncidentsHeatmapDetails, action.payload, cancelToken);
    yield put({
      type: generalActions.GET_RECENT_INCIDENTS_HEATMAP_SUCCESS_DETAILS,
      payload: res.data.data,
    });
  } catch (err) {
    yield put({
      type: generalActions.GET_RECENT_INCIDENTS_HEATMAP_FAIL_DETAILS,
      payload: { error: err.message },
    });
    if (err?.response?.status === 401) yield put({ type: authActions.AUTH_LOGOUT_REQUEST });
  } finally {
    if (yield cancelled()) {
      console.log('getRecentIncidentsHeatmapDetails cancelled');
    }
  }
}

function* getRecentIncidentHeatmapLookUps(action, cancelToken) {
  try {
    const res = yield call(Api.general.getRecentIncidentHeatmapLookUps, action.payload, cancelToken);
    yield put({
      type: generalActions.GET_HEATMAP_FILTER_LOOKUPS_SUCCESS,
      payload: res.data.data,
    });
  } catch (err) {
    yield put({
      type: generalActions.GET_HEATMAP_FILTER_LOOKUPS_FAILURE,
      payload: { error: err.message },
    });
    if (err?.response?.status === 401) yield put({ type: authActions.AUTH_LOGOUT_REQUEST });
  } finally {
    if (yield cancelled()) {
      console.log('getHeatMapLookUps cancelled');
    }
  }
}

function* getUsers(action, cancelToken) {
  try {
    const res = yield call(Api.general.getUsers, action.payload, cancelToken);
    yield put({
      type: generalActions.GET_USERS_SUCCESS,
      payload: res.data,
    });
  } catch (err) {
    yield put({
      type: generalActions.GET_USERS_FAIL,
      payload: { error: err.message },
    });
    if (err?.response?.status === 401) yield put({ type: authActions.AUTH_LOGOUT_REQUEST });
  } finally{
    if (yield cancelled()) {
      console.log('getUsers cancelled:', getUsers.name);
    }
  }
}

function* getAllUsers(action, cancelToken) {
  try {
    const res = yield call(Api.general.getAllUsers, action.payload, cancelToken);
    yield put({
      type: generalActions.GET_USER_LIST_SUCCESS,
      payload: res.data,
    });
  } catch (err) {
    yield put({
      type: generalActions.GET_USER_LIST_FAIL,
      payload: { error: err.message },
    });
    if (err?.response?.status === 401) yield put({ type: authActions.AUTH_LOGOUT_REQUEST });
  } finally{
    if (yield cancelled()) {
      console.log('getUsers cancelled:', getUsers.name);
    }
  }
}

function* saveUser(action, cancelToken) {
  try {
    const res = yield call(Api.general.saveUser, action.payload, cancelToken);
    yield put({
      type: generalActions.SAVE_USER_SUCCESS,
      payload: res.data.data,
    });
  } catch (err) {
    yield put({
      type: generalActions.SAVE_USER_FAIL,
      payload: { error: err.message },
    });
    if (err?.response?.status === 401) yield put({ type: authActions.AUTH_LOGOUT_REQUEST });
  }finally{
    if (yield cancelled()) {
      console.log('saveUser cancelled');
    }
  }
}

function* getIncidents(action, cancelToken) {
  try {
    const res = yield call(Api.general.getIncidents, action.payload, cancelToken);
    yield put({
      type: generalActions.GET_INCIDENTS_SUCCESS,
      payload: res.data.data,
    });
  } catch (err) {
    yield put({
      type: generalActions.GET_INCIDENTS_FAIL,
      payload: { error: err.message },
    });
    if (err?.response?.status === 401) yield put({ type: authActions.AUTH_LOGOUT_REQUEST });
  }finally{
    if (yield cancelled()) {
      console.log('getIncidents cancelled');
    }
  }
}

function* getIncidentDetails(action, cancelToken) {
  try {
    const res = yield call(Api.general.getIncidentDetails, action.payload, cancelToken);
    yield put({
      type: generalActions.GET_INCIDENT_DETAILS_SUCCESS,
      payload: res.data.data,
    });
  } catch (err) {
    yield put({
      type: generalActions.GET_INCIDENT_DETAILS_FAIL,
      payload: { error: err.message },
    });
    if (err?.response?.status === 401) yield put({ type: authActions.AUTH_LOGOUT_REQUEST });
  }finally{
    if (yield cancelled()) {
      console.log('getIncidentDetails cancelled');
    }
  }
}

function* getFilterLookups(action, cancelToken) {
  try {
    const res = yield call(Api.general.getFilterLookups, action.payload, cancelToken);
    yield put({
      type: generalActions.GET_FILTER_LOOKUP_SUCCESS,
      payload: res.data.data
    });
  } catch (err) {
    yield put({
      type: generalActions.GET_FILTER_LOOKUP_FAIL,
      payload: { error: err.message },
    });
    if (err?.response?.status === 401) yield put({ type: authActions.AUTH_LOGOUT_REQUEST });
  }finally{
    if (yield cancelled()) {
      console.log('getFilterLookups cancelled:');
    }
  }
}

function* getSummary(action, cancelToken) {
  try {
    const res = yield call(Api.general.getSummary, action.payload, cancelToken);
    const res2 = yield call(Api.general.getLastRefreshDate, action.payload, cancelToken)

    yield put({
      type: generalActions.GET_SUMMARY_SUCCESS,
      payload: res.data.data,
    });
    yield put({
      type: generalActions.GET_LAST_REFRESH_DATE_SUCCESS,
      payload: res2.data?.data.RefreshDate,
    });
    action.callback();
  } catch (err) {
    yield put({
      type: generalActions.GET_SUMMARY_FAIL,
      payload: { error: err.message },
    });
    if (err?.response?.status === 401) yield put({ type: authActions.AUTH_LOGOUT_REQUEST });
  }finally{
    if (yield cancelled()) {
      console.log('getSummary cancelled');
    }
  }
}

function* getDetectionQualityIncidents(action, cancelToken) {
  try {
    const res = yield call(Api.general.getDetectionQualityIncidents, action.payload, cancelToken);
    yield put({
      type: generalActions.GET_DETECTION_QUALITY_INCIDENTS_SUCCESS,
      payload: res.data.data,
    });
  } catch (err) {
    yield put({
      type: generalActions.GET_DETECTION_QUALITY_INCIDENTS_FAIL,
      payload: { error: err.message },
    });
    if (err?.response?.status === 401) yield put({ type: authActions.AUTH_LOGOUT_REQUEST });
  }finally{
    if (yield cancelled()) {
      console.log('getDetectionQualityIncidents cancelled');
    }
  }
}

function* getDetectionQualityIncidentDetails(action, cancelToken) {
  try {
    const res = yield call(Api.general.getDetectionQualityIncidentDetails, action.payload, cancelToken);
    yield put({
      type: generalActions.GET_DETECTION_QUALITY_INCIDENT_DETAILS_SUCCESS,
      payload: res.data.data,
    });
  } catch (err) {
    yield put({
      type: generalActions.GET_DETECTION_QUALITY_INCIDENT_DETAILS_FAIL,
      payload: { error: err.message },
    });
    if (err?.response?.status === 401) yield put({ type: authActions.AUTH_LOGOUT_REQUEST });
  }finally{
    if (yield cancelled()) {
      console.log('getDetectionQualityIncidentDetails cancelled');
    }
  }
}

function* getDetectionQualityFilterLookups(action, cancelToken) {
  try {
    const res = yield call(Api.general.getDetectionQualityFilterLookups, action.payload, cancelToken);
    yield put({
      type: generalActions.GET_DETECTION_QUALITY_FILTER_LOOKUP_SUCCESS,
      payload: {...res.data.data, municipality: res.data.data.city}
    });
  } catch (err) {
    yield put({
      type: generalActions.GET_DETECTION_QUALITY_FILTER_LOOKUP_FAIL,
      payload: { error: err.message },
    });
    if (err?.response?.status === 401) yield put({ type: authActions.AUTH_LOGOUT_REQUEST });
  }finally{
    if (yield cancelled()) {
      console.log('getDetectionQualityFilterLookups cancelled');
    }
  }
}

function* getDetectionQualitySummary(action, cancelToken) {
  try {
    const res = yield call(Api.general.getDetectionQualitySummary, action.payload, cancelToken);

    yield put({
      type: generalActions.GET_DETECTION_QUALITY_SUMMARY_SUCCESS,
      payload: res.data.data,
    });
    yield put({
      type: generalActions.GET_LAST_REFRESH_DATE_REQUEST,
      payload: action.payload,
    });
    action.callback();
  } catch (err) {
    yield put({
      type: generalActions.GET_DETECTION_QUALITY_SUMMARY_FAIL,
      payload: { error: err.message },
    });
    if (err?.response?.status === 401) yield put({ type: authActions.AUTH_LOGOUT_REQUEST });
  }finally{
    if (yield cancelled()) {
      console.log('getDetectionQualitySummary cancelled');
    }
  }
}

function* getLastRefreshDate(action, cancelToken) {
  try {
    const res = yield call(Api.general.getLastRefreshDate, action.payload, cancelToken)

    yield put({
      type: generalActions.GET_LAST_REFRESH_DATE_SUCCESS,
      payload: res.data?.data.RefreshDate,
    });
    action.callback();
  } catch (err) {
    yield put({
      type: generalActions.GET_LAST_REFRESH_DATE_FAIL,
      payload: { error: err.message },
    });
    if (err?.response?.status === 401) yield put({ type: authActions.AUTH_LOGOUT_REQUEST });
  }finally{
    if (yield cancelled()) {
      console.log('getLastFreshDate cancelled');
    }
  }
}

function* getSmartSupervisionSummary(action, cancelToken) {
  try {
    const res = yield call(Api.general.getSmartSupervisionSummary, action.payload, cancelToken);

    yield put({
      type: generalActions.GET_SMART_SUPERVISION_SUMMARY_SUCCESS,
      payload: res.data.data,
    });
    action.callback();
  } catch (err) {
    yield put({
      type: generalActions.GET_SMART_SUPERVISION_SUMMARY_FAIL,
      payload: { error: err.message },
    });
    if (err?.response?.status === 401) yield put({ type: authActions.AUTH_LOGOUT_REQUEST });
  }finally{
    if (yield cancelled()) {
      console.log('getSmartSupervisionSummary cancelled');
    }
  }
}

function* getMunicipalityAndStreetData(action, cancelToken) {
  try {
    const res = yield call(Api.general.getMunicipalityAndStreetData, action.payload, cancelToken);
    const data = res.data.data;
    data.municipality = data.municipality.map(item => {
      return {
        ...item,
        geoData: parsePolygonPaths(item.geoData)
      }
    })
    data.street = data.street.map(item => {
      return {
        ...item,
        geoData: parsePolygonPaths(item.geoData) //convertWKTMultiPointToGoogleMapsPath(item.geoData)
      }
    })
    yield put({
      type: generalActions.GET_MUNICIPALITY_AND_STREET_DATA_SUCCESS,
      payload: data,
    });
  } catch (err) {
    yield put({
      type: generalActions.GET_MUNICIPALITY_AND_STREET_DATA_FAIL,
      payload: { error: err.message },
    });
    if (err?.response?.status === 401) yield put({ type: authActions.AUTH_LOGOUT_REQUEST });
  }finally{
    if (yield cancelled()) {
      console.log('getMunicipalityAndStreetData cancelled');
    }
  }
}

function* getMunicipalityAndStreetDataSmartSupervision(action, cancelToken) {
  try {
    const res = yield call(Api.general.getMunicipalityAndStreetDataSmartSupervision, action.payload, cancelToken);
    const data = res.data.data;
    data.municipality = data.municipality.map(item => {
      return {
        ...item,
        geoData: parsePolygonPaths(item.geoData)
      }
    })
    data.street = data.street.map(item => {
      return {
        ...item,
        geoData: parsePolygonPaths(item.geoData) //convertWKTMultiPointToGoogleMapsPath(item.geoData)
      }
    })
    yield put({
      type: generalActions.GET_MUNICIPALITY_AND_STREET_DATA_SMART_SUPERVISION_SUCCESS,
      payload: data,
    });
  } catch (err) {
    yield put({
      type: generalActions.GET_MUNICIPALITY_AND_STREET_DATA_SMART_SUPERVISION_FAIL,
      payload: { error: err.message },
    });
    if (err?.response?.status === 401) yield put({ type: authActions.AUTH_LOGOUT_REQUEST });
  }finally{
    if (yield cancelled()) {
      console.log('getMunicipality and streetsmartdata cancelled');
    }
  }
}

function* getHighElementsData(action) {
  try {
    const res = yield call(Api.general.getHighElementsData, action.payload);
    const data = res.data.data;
    // console.log('getHighElementsData: ', res.data)
    // data.district = data.district.map(item => {
    //   return {
    //     ...item,
    //     geoData: parsePolygonPaths(item.geoData)
    //   }
    // })
    data.street = data.street.map(item => {
      return {
        ...item,
        geoData: parsePolygonPaths(item.geoData)
      }
    })
    yield put({
      type: generalActions.GET_HIGHEST_ELEMENTS_DATA_SUCCESS,
      payload: data,
    });
  } catch (err) {
    yield put({
      type: generalActions.GET_HIGHEST_ELEMENTS_DATA_FAIL,
      payload: { error: err.message },
    });
    if (err?.response?.status === 401) yield put({ type: authActions.AUTH_LOGOUT_REQUEST });
  }finally{
    if (yield cancelled()) {
      console.log('getDetectionQualityIncidents cancelled');
    }
  }
}

function* getVPIData(action) {
  try {
    const res = yield call(Api.general.getVPIData, action.payload);
    const data = res.data.data;
    data.district = data.district.map(item => {
      return {
        ...item,
        geoData: parsePolygonPaths(item.geoData)
      }
    })
    data.street = data.street.map(item => {
      return {
        ...item,
        geoData: parsePolygonPaths(item.geoData)
      }
    })
    yield put({
      type: generalActions.GET_VPI_DATA_SUCCESS,
      payload: data,
    });
  } catch (err) {
    yield put({
      type: generalActions.GET_VPI_DATA_FAIL,
      payload: { error: err.message },
    });
    if (err?.response?.status === 401) yield put({ type: authActions.AUTH_LOGOUT_REQUEST });
  }finally{
    if (yield cancelled()) {
      console.log('getVPIdata cancelled');
    }
  }
}

function* getCoverageStreetData(action) {
  try {
    const res = yield call(Api.general.getCoverageStreetData, action.payload);
    const data = res.data.data.map(item => {
      return {
        ...item,
        geoData: parsePolygonPaths(item.geoData)
      }
    })
    yield put({
      type: generalActions.GET_COVERAGE_STREET_DATA_SUCCESS,
      payload: data,
    });
  } catch (err) {
    yield put({
      type: generalActions.GET_COVERAGE_STREET_DATA_FAIL,
      payload: { error: err.message },
    });
    if (err?.response?.status === 401) yield put({ type: authActions.AUTH_LOGOUT_REQUEST });
  }finally{
    if (yield cancelled()) {
      console.log('getStreetCoverage cancelled');
    }
  }
}

function* getVPITrends(action, cancelToken) {
  try {
    const res = yield call(Api.general.getVPITrends, action.payload, cancelToken);
    yield put({
      type: generalActions.GET_VPI_TRENDS_SUCCESS,
      payload: res.data.data,
    });
  } catch (err) {
    yield put({
      type: generalActions.GET_VPI_TRENDS_FAIL,
      payload: { error: err.message },
    });
    if (err?.response?.status === 401) yield put({ type: authActions.AUTH_LOGOUT_REQUEST });
  }finally{
    if (yield cancelled()) {
      console.log('getVPITrends cancelled');
    }
  }
}

function* getStreetCoverage(action, cancelToken) {
  try {
    const res = yield call(Api.general.getStreetCoverage, action.payload, cancelToken);
    const data = res.data.data.map(item => {
      return {
        ...item,
        GeoData: item.GeoData.replace(/[^\d .-]/g,'').trim().split(/\s+/)
      }
    })
    yield put({
      type: generalActions.GET_STREET_COVERAGE_SUCCESS,
      payload: data,
    });
  } catch (err) {
    yield put({
      type: generalActions.GET_STREET_COVERAGE_FAIL,
      payload: { error: err.message },
    });
    if (err?.response?.status === 401) yield put({ type: authActions.AUTH_LOGOUT_REQUEST });
  }finally{
    if (yield cancelled()) {
      console.log('getStreetCoverage cancelled');
    }
  }
}

function* getRoadOptions(action, cancelToken) {
  try {
    const res = yield call(Api.general.getRoadOptions, action.payload, cancelToken);
    yield put({
      type: generalActions.GET_ROAD_OPTIONS_SUCCESS,
      payload: res.data.data,
    });
  } catch (err) {
    yield put({
      type: generalActions.GET_ROAD_OPTIONS_FAIL,
      payload: { error: err.message },
    });
    if (err?.response?.status === 401) yield put({ type: authActions.AUTH_LOGOUT_REQUEST });
  }finally{
    if (yield cancelled()) {
      console.log('getRoadOptions cancelled');
    }
  }
}

function* getCoverageProgress(action, cancelToken) {
  try {
    const res = yield call(Api.general.getCoverageProgress, action.payload, cancelToken);
    const data = {
      labels: res.data.data.labels,
      datasets: [{
          label: 'Coverage Progress',
          data: res.data.data.data,
          type: 'bar',
          pointRadius: 0,
          backgroundColor: '#0579DF',
        }
      ],
    };
    yield put({
      type: generalActions.GET_COVERAGE_PROGRESS_SUCCESS,
      payload: data,
    });
  } catch (err) {
    yield put({
      type: generalActions.GET_COVERAGE_PROGRESS_FAIL,
      payload: { error: err.message },
    });
    if (err?.response?.status === 401) yield put({ type: authActions.AUTH_LOGOUT_REQUEST });
  }finally{
    if (yield cancelled()) {
      console.log('getCoverageProgress cancelled');
    }
  }
}

function* getDepartments(action, cancelToken) {
  try {
    const res = yield call(Api.general.getDepartments, action.payload, cancelToken);
    yield put({
      type: generalActions.GET_DEPARTMENTS_SUCCESS,
      payload: res.data.data,
    });
  } catch (err) {
    yield put({
      type: generalActions.GET_DEPARTMENTS_FAIL,
      payload: { error: err.message },
    });
  }finally{
    if (yield cancelled()) {
      console.log('getDepartments cancelled');
    }
  }
}


function* getDepartmentDataSummary(action, cancelToken) {
  try {
    const res = yield call(Api.general.getDepartmentDataSummary, action.payload, cancelToken);
    yield put({
      type: generalActions.GET_DEPARTMENT_DATA_SUMMARY_SUCCESS,
      payload: res.data.data,
    });
  } catch (err) {
    yield put({
      type: generalActions.GET_DEPARTMENT_DATA_SUMMARY_FAIL,
      payload: { error: err.message },
    });
    if (err?.response?.status === 401) yield put({ type: authActions.AUTH_LOGOUT_REQUEST });
  }finally{
    if (yield cancelled()) {
      console.log('getDepartmentDataSummary cancelled');
    }
  }
}




export default all([
  takeLatest(generalActions.BACKEND_REDIRECTION_REQUEST, function* (action) {
    yield call(cancelable, backendRedirection, action);
  }),
  takeLatest(generalActions.GET_INCIDENTS_REQUEST, function* (action) {
    yield call(cancelable, getIncidents, action);
  }),
  takeLatest(generalActions.GET_INCIDENT_DETAILS_REQUEST, function* (action) {
    yield call(cancelable, getIncidentDetails, action);
  }),
  takeLatest(generalActions.GET_FILTER_LOOKUP_REQUEST, function* (action) {
    yield call(cancelable, getFilterLookups, action);
  }),
  takeLatest(generalActions.GET_DETECTION_QUALITY_INCIDENTS_REQUEST, function* (action) {
    yield call(cancelable, getDetectionQualityIncidents, action);
  }),
  takeLatest(generalActions.GET_DETECTION_QUALITY_INCIDENT_DETAILS_REQUEST, function* (action) {
    yield call(cancelable, getDetectionQualityIncidentDetails, action);
  }),
  takeLatest(generalActions.GET_DETECTION_QUALITY_FILTER_LOOKUP_REQUEST, function* (action) {
    yield call(cancelable, getDetectionQualityFilterLookups, action);
  }),
  takeLatest(generalActions.GET_SUMMARY_REQUEST, function* (action) {
    yield call(cancelable, getSummary, action);
  }),
  takeLatest(generalActions.GET_DETECTION_QUALITY_SUMMARY_REQUEST, function* (action) {
    yield call(cancelable, getDetectionQualitySummary, action);
  }),
  takeLatest(generalActions.GET_LAST_REFRESH_DATE_REQUEST, function* (action) {
    yield call(cancelable, getLastRefreshDate, action);
  }),
  takeLatest(generalActions.GET_SMART_SUPERVISION_SUMMARY_REQUEST, function* (action) {
    yield call(cancelable, getSmartSupervisionSummary, action);
  }),
  takeLatest(generalActions.GET_MUNICIPALITY_AND_STREET_DATA_REQUEST, function* (action) {
    yield call(cancelable, getMunicipalityAndStreetData, action);
  }),
  takeLatest(generalActions.GET_MUNICIPALITY_AND_STREET_DATA_SMART_SUPERVISION_REQUEST, function* (action) {
    yield call(cancelable, getMunicipalityAndStreetDataSmartSupervision, action);
  }),
  takeLatest(generalActions.GET_HIGHEST_ELEMENTS_DATA_REQUEST, function* (action) {
    yield call(cancelable, getHighElementsData, action);
  }),
  takeLatest(generalActions.GET_VPI_DATA_REQUEST, function* (action) {
    yield call(cancelable, getVPIData, action);
  }),
  takeLatest(generalActions.GET_COVERAGE_STREET_DATA_REQUEST, function* (action) {
    yield call(cancelable, getCoverageStreetData, action);
  }),
  takeLatest(generalActions.GET_VPI_TRENDS_REQUEST, function* (action) {
    yield call(cancelable, getVPITrends, action);
  }),
  takeLatest(generalActions.GET_STREET_COVERAGE_REQUEST, function* (action) {
    yield call(cancelable, getStreetCoverage, action);
  }),
  takeLatest(generalActions.GET_ROAD_OPTIONS_REQUEST, function* (action) {
    yield call(cancelable, getRoadOptions, action);
  }),
  takeLatest(generalActions.GET_COVERAGE_PROGRESS_REQUEST, function* (action) {
    yield call(cancelable, getCoverageProgress, action);
  }),
  takeLatest(generalActions.GET_USERS_REQUEST, function* (action) {
    yield call(cancelable, getUsers, action);
  }),
  takeLatest(generalActions.GET_USER_LIST_REQUEST, function* (action) {
    yield call(cancelable, getAllUsers, action);
  }),
  takeLatest(generalActions.SAVE_USER_REQUEST, function* (action) {
    yield call(cancelable, saveUser, action);
  }),
  takeLatest(generalActions.GET_DEPARTMENTS_REQUEST, function* (action) {
    yield call(cancelable, getDepartments, action);
  }),
  takeLatest(generalActions.GET_DEPARTMENT_DATA_SUMMARY_REQUEST, function* (action) {
    yield call(cancelable, getDepartmentDataSummary, action);
  }),
  takeLatest(generalActions.GET_RECENT_INCIDENTS_HEATMAP_REQUEST, function* (action) {
    yield call(cancelable, getRecentIncidentsHeatmap, action);
  }),
  takeLatest(generalActions.GET_RECENT_INCIDENTS_HEATMAP_REQUEST_DETAILS, function* (action) {
    yield call(cancelable, getRecentIncidentsHeatmapDetails, action);
  }),
  takeLatest(generalActions.GET_HEATMAP_FILTER_LOOKUPS_REQUEST, function* (action) {
    yield call(cancelable, getRecentIncidentHeatmapLookUps, action);
  }),

  ]
);
